import { getProductsGroupOptions } from '@/modules/ProductGroup/services'
import { useQuery } from '@tanstack/react-query'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormItem } from 'vnetwork-ui'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface ProductGroupSelectProps<T extends FieldValues> {
    control: UseFormReturn<T, any, any>['control']
    name: Path<T>
    onChangeAfterHookForm?: () => void
    multiple?: boolean
    showLabel?: boolean
    label?: string
    placeholder?: string
    disabledProductGroups?: string[]
}

const ProductGroupSelect = <T extends FieldValues>({
    control,
    name,
    showLabel = true,
    label: labelOverride,
    placeholder: placeholderOverride,
    onChangeAfterHookForm,
    multiple = false,
    disabledProductGroups = [],
}: ProductGroupSelectProps<T>) => {
    const { data, isFetching } = useQuery({
        queryKey: [QUERY_KEYS.PRODUCT_GROUPS],
        queryFn: getProductsGroupOptions,
    })

    const { t } = useTranslation()

    return (
        <FormItem
            control={control}
            name={name}
            multiple={multiple}
            type="select"
            label={
                showLabel ? (labelOverride ?? t('product.groups')) : undefined
            }
            placeholder={placeholderOverride ?? t('product.groups')}
            options={data?.filter(
                (group) => !disabledProductGroups.includes(group?.value)
            )}
            allowClear={false}
            disabled={isFetching}
            loading={isFetching}
            onChangeAfterHookForm={() => {
                onChangeAfterHookForm?.()
            }}
        />
    )
}

export default ProductGroupSelect
